export const faWarnIfIconSpecMissing = () => {
  throw new Error('Property `icon` is required for `fa-icon`/`fa-duotone-icon` components.');
};
